const childRoutes = prop => [
    {
        path: 'street-child-details-report',
        name: prop + '.street_child_details_report',
        meta: { auth: true },
        component: () => import('../pages/street-child-details-report/List.vue')
    }
]
const routes = [
    {
        path: '/street-children-service/report',
        name: 'street_children_service.report',
        component: () => import('@/layouts/StreetChildrenService.vue'),
        meta: { auth: true },
        children: childRoutes('street_children_service.street_children')
    }
]

export default routes
